export enum FormTypeEnum {
    DEMAND_LETTER = 'demand_letter',
    SOFT = 'soft',
    HARD = 'hard'
}
